import React, { useState } from 'react'
import { ReactComponent as FullscreenIcon } from '../assets/icons/fullscreen_32dp_000000_FILL0_wght300_GRAD0_opsz40.svg'
import { ReactComponent as CloseFullscreenIcon } from '../assets/icons/close_fullscreen_32dp_000000_FILL0_wght400_GRAD0_opsz40.svg'
import { ReactComponent as ArrowLeft } from '../assets/icons/arrow_back_32dp_000000_FILL0_wght300_GRAD0_opsz40.svg'
import { ReactComponent as ArrowRight } from '../assets/icons/arrow_forward_32dp_000000_FILL0_wght300_GRAD0_opsz40.svg'
import { ReactComponent as RefreshIcon } from '../assets/icons/refresh_32dp_000000_FILL0_wght300_GRAD0_opsz40.svg'
import { ReactComponent as HomeIcon } from '../assets/icons/home_32dp_000000_FILL0_wght300_GRAD0_opsz40.svg'

export default function ControllerModalBrowserChrome({
    url,
    canGoBack,
    canGoForward,
    isFullscreen,
    tappedKey,
    onTap,
    onClear,
}) {
    const [showClearMenu, setShowClearMenu] = useState(false)
    const displayUrl = url ? url.replace(/^https?:\/\//, '') : ''
    const isActive = (type) => tappedKey === `chrome:${type}`

    const handleClear = (clearType) => {
        onClear && onClear(clearType)
        setShowClearMenu(false)
    }

    return (
        <>
            <style>{`
                .mb-chrome-icon svg { width: 36px; height: 36px; display: block; }
                .mb-chrome-icon svg path { fill: #fff; }
                .mb-chrome-icon svg path[stroke],
                .mb-chrome-icon svg line[stroke],
                .mb-chrome-icon svg polygon[stroke] { stroke: #fff; fill: none; }
            `}</style>
            <div style={s.chrome}>
                <button
                    className="mb-chrome-icon"
                    style={{ ...s.chromeBtn, opacity: canGoBack ? 1 : 0.3, ...(isActive('modal-browser-back') ? s.chromeBtnActive : {}) }}
                    onClick={() => onTap('modal-browser-back')}
                    aria-label="Back"
                ><ArrowLeft /></button>
                <button
                    className="mb-chrome-icon"
                    style={{ ...s.chromeBtn, opacity: canGoForward ? 1 : 0.3, ...(isActive('modal-browser-forward') ? s.chromeBtnActive : {}) }}
                    onClick={() => onTap('modal-browser-forward')}
                    aria-label="Forward"
                ><ArrowRight /></button>
                <button
                    className="mb-chrome-icon"
                    style={{ ...s.chromeBtn, ...(isActive('modal-browser-reload') ? s.chromeBtnActive : {}) }}
                    onClick={() => onTap('modal-browser-reload')}
                    aria-label="Reload"
                ><RefreshIcon /></button>
                <button
                    className="mb-chrome-icon"
                    style={{ ...s.chromeBtn, ...(isActive('modal-browser-home') ? s.chromeBtnActive : {}) }}
                    onClick={() => onTap('modal-browser-home')}
                    aria-label="Home"
                ><HomeIcon /></button>
                <span style={s.urlText} title={url}>{displayUrl}</span>
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                    {showClearMenu ? (
                        <>
                            <button style={s.clearBtn} onClick={() => handleClear('cache')}>Clear Cache</button>
                            <button style={s.clearBtn} onClick={() => handleClear('cookies')}>Clear Cookies</button>
                            <button style={s.clearBtn} onClick={() => handleClear('all')}>Clear All</button>
                        </>
                    ) : (
                        <button
                            className="mb-chrome-icon"
                            style={{ ...s.chromeBtn, ...(isActive('modal-browser-fullscreen') ? s.chromeBtnActive : {}) }}
                            onClick={() => onTap('modal-browser-fullscreen')}
                            aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
                        >{isFullscreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}</button>
                    )}
                    <button
                        className="mb-chrome-icon"
                        style={{ ...s.chromeBtn, flexShrink: 0 }}
                        onClick={() => setShowClearMenu(v => !v)}
                        aria-label="Clear data"
                    >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </>
    )
}

const s = {
    chrome: {
        display: 'flex', alignItems: 'center', gap: 4,
        padding: '6px 8px',
        background: '#555555',
        borderRadius: 999,
        margin: '12px 12px 8px',
        flexShrink: 0,
    },
    chromeBtn: {
        background: 'transparent',
        border: 'none',
        color: '#fff', borderRadius: 999,
        width: 36, height: 36, fontSize: 16,
        cursor: 'pointer', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background 0.12s ease',
    },
    chromeBtnActive: {
        background: 'rgba(255,210,80,0.45)',
    },
    urlText: {
        fontSize: 16, color: '#fff',
        marginLeft: 5,
        whiteSpace: 'nowrap', overflow: 'hidden',
        textOverflow: 'ellipsis', display: 'block',
    },
    clearBtn: {
        padding: '5px 12px',
        fontSize: 13,
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none',
        borderRadius: 999,
        cursor: 'pointer',
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
}
